
import ConfirmationModel from '@/components/ConfirmationModel';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class ConfirmCancel extends Vue {
    @Prop({
        type: ConfirmationModel,
        required: true,
    })
    public confirmationModel!: ConfirmationModel;
    public message: string = '';
    public dialogOpen: boolean = false;

    public get dialogWidth(): string {
        return this.$vuetify.breakpoint.smAndDown ? 'calc(100vw)' : '410px';
    }

    public mounted() {
        this.confirmationModel.on('confirm', (message: string) => {
            this.dialogOpen = true;
            this.message = message;
        });
    }
}

export { ConfirmationModel };
